import { __module as _ } from "./chunk684.js";
import { __require as X } from "./chunk447.js";
import { __require as S } from "./chunk451.js";
import { __require as k } from "./chunk453.js";
import { __require as g } from "./chunk463.js";
import { __require as w } from "./chunk464.js";
var z = _.exports, C;
function $() {
  return C ? _.exports : (C = 1, function(y, B) {
    (function(b, u, p) {
      y.exports = u(X(), S(), k(), g(), w());
    })(z, function(b) {
      return function() {
        var u = b, p = u.lib, m = p.StreamCipher, L = u.algo, i = [], v = [], f = [], R = L.RabbitLegacy = m.extend({
          _doReset: function() {
            var r = this._key.words, a = this.cfg.iv, t = this._X = [
              r[0],
              r[3] << 16 | r[2] >>> 16,
              r[1],
              r[0] << 16 | r[3] >>> 16,
              r[2],
              r[1] << 16 | r[0] >>> 16,
              r[3],
              r[2] << 16 | r[1] >>> 16
            ], e = this._C = [
              r[2] << 16 | r[2] >>> 16,
              r[0] & 4294901760 | r[1] & 65535,
              r[3] << 16 | r[3] >>> 16,
              r[1] & 4294901760 | r[2] & 65535,
              r[0] << 16 | r[0] >>> 16,
              r[2] & 4294901760 | r[3] & 65535,
              r[1] << 16 | r[1] >>> 16,
              r[3] & 4294901760 | r[0] & 65535
            ];
            this._b = 0;
            for (var o = 0; o < 4; o++)
              h.call(this);
            for (var o = 0; o < 8; o++)
              e[o] ^= t[o + 4 & 7];
            if (a) {
              var d = a.words, s = d[0], x = d[1], c = (s << 8 | s >>> 24) & 16711935 | (s << 24 | s >>> 8) & 4278255360, n = (x << 8 | x >>> 24) & 16711935 | (x << 24 | x >>> 8) & 4278255360, l = c >>> 16 | n & 4294901760, q = n << 16 | c & 65535;
              e[0] ^= c, e[1] ^= l, e[2] ^= n, e[3] ^= q, e[4] ^= c, e[5] ^= l, e[6] ^= n, e[7] ^= q;
              for (var o = 0; o < 4; o++)
                h.call(this);
            }
          },
          _doProcessBlock: function(r, a) {
            var t = this._X;
            h.call(this), i[0] = t[0] ^ t[5] >>> 16 ^ t[3] << 16, i[1] = t[2] ^ t[7] >>> 16 ^ t[5] << 16, i[2] = t[4] ^ t[1] >>> 16 ^ t[7] << 16, i[3] = t[6] ^ t[3] >>> 16 ^ t[1] << 16;
            for (var e = 0; e < 4; e++)
              i[e] = (i[e] << 8 | i[e] >>> 24) & 16711935 | (i[e] << 24 | i[e] >>> 8) & 4278255360, r[a + e] ^= i[e];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function h() {
          for (var r = this._X, a = this._C, t = 0; t < 8; t++)
            v[t] = a[t];
          a[0] = a[0] + 1295307597 + this._b | 0, a[1] = a[1] + 3545052371 + (a[0] >>> 0 < v[0] >>> 0 ? 1 : 0) | 0, a[2] = a[2] + 886263092 + (a[1] >>> 0 < v[1] >>> 0 ? 1 : 0) | 0, a[3] = a[3] + 1295307597 + (a[2] >>> 0 < v[2] >>> 0 ? 1 : 0) | 0, a[4] = a[4] + 3545052371 + (a[3] >>> 0 < v[3] >>> 0 ? 1 : 0) | 0, a[5] = a[5] + 886263092 + (a[4] >>> 0 < v[4] >>> 0 ? 1 : 0) | 0, a[6] = a[6] + 1295307597 + (a[5] >>> 0 < v[5] >>> 0 ? 1 : 0) | 0, a[7] = a[7] + 3545052371 + (a[6] >>> 0 < v[6] >>> 0 ? 1 : 0) | 0, this._b = a[7] >>> 0 < v[7] >>> 0 ? 1 : 0;
          for (var t = 0; t < 8; t++) {
            var e = r[t] + a[t], o = e & 65535, d = e >>> 16, s = ((o * o >>> 17) + o * d >>> 15) + d * d, x = ((e & 4294901760) * e | 0) + ((e & 65535) * e | 0);
            f[t] = s ^ x;
          }
          r[0] = f[0] + (f[7] << 16 | f[7] >>> 16) + (f[6] << 16 | f[6] >>> 16) | 0, r[1] = f[1] + (f[0] << 8 | f[0] >>> 24) + f[7] | 0, r[2] = f[2] + (f[1] << 16 | f[1] >>> 16) + (f[0] << 16 | f[0] >>> 16) | 0, r[3] = f[3] + (f[2] << 8 | f[2] >>> 24) + f[1] | 0, r[4] = f[4] + (f[3] << 16 | f[3] >>> 16) + (f[2] << 16 | f[2] >>> 16) | 0, r[5] = f[5] + (f[4] << 8 | f[4] >>> 24) + f[3] | 0, r[6] = f[6] + (f[5] << 16 | f[5] >>> 16) + (f[4] << 16 | f[4] >>> 16) | 0, r[7] = f[7] + (f[6] << 8 | f[6] >>> 24) + f[5] | 0;
        }
        u.RabbitLegacy = m._createHelper(R);
      }(), b.RabbitLegacy;
    });
  }(_), _.exports);
}
export {
  $ as __require
};
